module.exports = __webpack_public_path__ + "img/next-prev-sprite-hover.989fede0.png";